//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isUsingNewLayout } from '~/utils/isUsingNewLayout'
import getPage from '~/gql/getPage'
import getArticleTopicDetails from '~/gql/getArticleTopicDetails'
import head from '~/mixins/head'

export default {
  name: 'PageDepth2',
  mixins: [head],
  async asyncData({ $graphcms, $readingTime, params, app, error, store }) {
    // initialize
    let { page } = {}
    let articles = []
    const itemsBreadcrumb = []
    const filters = {}

    // TOPIC
    const currentTopic = params.topic

    // topic details
    const articleTopicDetails = await $graphcms.request(
      getArticleTopicDetails,
      {
        slug: currentTopic,
        lang: [app.i18n.locale],
        assetLocales: [app.i18n.locale, app.i18n.defaultLocale],
      }
    )
    const articleTopic = articleTopicDetails.articleTopics[0]

    if (articleTopic) {
      // set page theme
      store.commit('global/setTheme', 'lime')
    }

    // PAGE
    // if there isn't any topic, than there should be a page (child)
    if (!articleTopic) {
      const slug = params.topic
      let navigationItems = []
      const navigationElements = ['Teaser', 'Carousel', 'ArticleTopic'] // todo: outsource
      const { pages } = await $graphcms.request(getPage, {
        slug,
        lang: [app.i18n.locale],
      })
      page = pages[0]

      // set page theme
      if (page && page.themeColor) {
        store.commit('global/setTheme', page.themeColor)
      }

      if (!page) {
        return error({ statusCode: 404, message: 'noContent' })
      } else if (page?.showPageNavigation) {
        navigationItems = page.elements.filter((pageElements) => {
          return (
            (pageElements.showInLayout ===
              (isUsingNewLayout(app.i18n.locale) ? 'NEW' : 'OLD') ||
              pageElements.showInLayout === 'BOTH' ||
              !pageElements.showInLayout) &&
            pageElements.carouselType !== 'topics' &&
            navigationElements.some((el) => pageElements.type.includes(el))
          )
        })

        if (navigationItems.length > 0) {
          page.elements.splice(1, 0, {
            type: 'PageNavigation',
            items: navigationItems,
            title: 'PageNavigation',
          })
        }
      }
      const elementsToShow = page.elements.filter(
        (pageElement) =>
          pageElement.showInLayout ===
            (isUsingNewLayout(app.i18n.locale) ? 'NEW' : 'OLD') ||
          pageElement.showInLayout === 'BOTH' ||
          !pageElement.showInLayout ||
          pageElement.type === 'PageNavigation'
      )
      page.elements = elementsToShow
      if (page.parentPage) itemsBreadcrumb.push(page.parentPage)
      itemsBreadcrumb.push({ title: page.title, slug: page.slug })
      page.elements = page.elements.map((element) => {
        if (element.type === 'PageIntroFlexible') {
          return {
            ...element,
            // eslint-disable-next-line object-shorthand
            itemsBreadcrumb: itemsBreadcrumb,
          }
        }
        return element
      })
    } else {
      // set theme for topic
      store.commit('global/setTheme', 'lime')

      const articleTopicLocales = {}
      articleTopic.localizations.forEach((articleTopicLocale) => {
        articleTopicLocales[articleTopicLocale.locale] = {
          topic: articleTopicLocale.slug,
        }
      })
      await store.dispatch('i18n/setRouteParams', {
        ...articleTopicLocales,
      })

      articles = articleTopic.items.filter((article) => article.title !== null)

      // add readingTime for Teasers
      articles = articles.map((article) => {
        if (article.fullText && article.fullText.text) {
          article.readingTime = $readingTime(article.fullText.text)
          delete article.fullText
        } else {
          article.readingTime = null
        }

        return article
      })

      for (const item of articles) {
        item.tags.forEach((tag) => {
          filters[tag.id] = { label: tag.title, checked: false }
        })
      }
    }

    // META
    const metaTitle = page
      ? page.seo?.metaTitle
        ? page.seo?.metaTitle
        : page.title
      : articleTopic?.seo?.metaTitle
      ? articleTopic?.seo?.metaTitle
      : articleTopic?.title

    const metaDescription = page
      ? page.seo?.metaDescription
        ? page.seo?.metaDescription
        : null
      : articleTopic?.seo?.metaDescription
      ? articleTopic?.seo?.metaDescription
      : null

    const ogImage = page
      ? page.seo?.ogImage
        ? page.seo?.ogImage
        : null
      : articleTopic?.seo?.ogImage
      ? articleTopic?.seo?.ogImage?.src
      : articleTopic?.image?.og

    // eslint-disable-next-line no-var
    var rootPageSlug = 'hearing-loss'
    if (articleTopic) {
      if (articleTopic.parentPage) {
        itemsBreadcrumb.push(articleTopic.parentPage)
        rootPageSlug = articleTopic.parentPage.slug
      }
      if (articleTopic.title)
        itemsBreadcrumb.push({ title: articleTopic.title, slug: params.topic })

      // add image to use in PageIntro
      if (articleTopic.image) {
        articleTopic.image.url = articleTopic.image.og
      }
      if (
        articleTopic.featuredArticles.length === 0 &&
        isUsingNewLayout(app.i18n.locale)
      )
        return error({ statusCode: 404, message: 'noContent' })
    }

    return {
      page,
      rootPageSlug,
      articleTopic,
      currentTopic,
      itemsBreadcrumb,
      articles,
      filters,
      metaTitle,
      metaDescription,
      ogImage,
      visibleCount: 6,
    }
  },

  computed: {
    newQuery() {
      const keys = Object.keys(this.filters)
      const query = keys
        .filter((key) => this.filters[key].checked) // get id of each filter Object that is checked === true
        .map((key) => {
          // get label of each tag and slugify it before adding it to query array
          // const label = this.filters[key].label
          const label = key
          return this.$slugify(label, {
            lower: true,
            remove: /[*+~.()'"!:@]/g,
          })
        })

      const queryString = query.join('+')
      return queryString
    },

    tagsFromQuery() {
      const query = this.$route.query.tags
      return query
    },

    visibleFeaturedArticles() {
      // Retorna apenas os artigos visíveis
      return this.articleTopic && this.articleTopic.featuredArticles
        ? this.articleTopic.featuredArticles.slice(0, this.visibleCount)
        : []
    },

    isUsingNewLayout() {
      return isUsingNewLayout(this.$i18n.locale)
    },
  },

  created() {
    this.useQueryParams()
  },
  methods: {
    updateFilter(id, checked) {
      this.filters[id].checked = checked
      const query = this.newQuery.length > 0 ? { tags: this.newQuery } : {}

      this.$router.push({ query: { ...query } })
    },
    useQueryParams() {
      const queryString = this.tagsFromQuery
      if (!queryString) {
        return
      }
      const query = queryString.split('+')

      query.forEach((filter) => {
        this.checkFiltersByQueryParams(filter)
      })
    },

    checkFiltersByQueryParams(filterFromQuery) {
      Object.keys(this.filters).forEach((filterId) => {
        // check if filter from query is id
        const parsedFilterId = this.$slugify(filterId, {
          lower: true,
          remove: /[*+~.()'"!:@]/g,
        })

        if (parsedFilterId === filterFromQuery) {
          this.filters[filterId].checked = true
          return
        }

        // check if filter from query is label
        const label = this.filters[filterId]?.label ?? null
        const parsedLabel = this.$slugify(label, {
          lower: true,
          remove: /[*+~.()'"!:@]/g,
        })

        if (parsedLabel === filterFromQuery) {
          this.filters[filterId].checked = true
        }
      })
    },

    showMore() {
      this.visibleCount += 6
    },
  },
}
